var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedulingBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 8.09503H10.9995V14.095L15.7495 16.945L16.4995 15.715L12.4995 13.345V8.09503ZM17.3365 1.90503L21.9435 5.75003L20.6635 7.28503L16.0535 3.44203L17.3365 1.90503ZM6.66252 1.90503L7.94452 3.44103L3.33652 7.28503L2.05652 5.74903L6.66252 1.90503ZM11.9995 4.09503C7.02952 4.09503 2.99952 8.12503 2.99952 13.095C2.99952 18.065 7.02952 22.095 11.9995 22.095C16.9695 22.095 20.9995 18.065 20.9995 13.095C20.9995 8.12503 16.9695 4.09503 11.9995 4.09503ZM11.9995 20.095C8.13952 20.095 4.99952 16.955 4.99952 13.095C4.99952 9.23503 8.13952 6.09503 11.9995 6.09503C15.8595 6.09503 18.9995 9.23503 18.9995 13.095C18.9995 16.955 15.8595 20.095 11.9995 20.095Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingBlack);
export default __webpack_public_path__ + "static/media/scheduling-black.414f25669bbd8f053636d0c5c51c7bf9.svg";
export { ForwardRef as ReactComponent };